export const PUBLICIP_STORE_KEY = 'publicIP';
export const PUBLICIP_SERVICE_KEY = 'publicIP';
export const PUBLICIP_API_URL =
  'https://static-assets.flydata.app/public-ip/public-ips.json';
